<div class="auth-flow-logo-container">
  <img src="assets/logo/dark/css-logo.svg" alt="CSS Logo" i18n-alt />
</div>

<div class="auth-flow-title">
  {{ authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  <div class="header" i18n>Enter Verification Code</div>
  <div>
    <span class="subtext" i18n>Please enter the verification code that was sent to </span>
    <span class="auth-highlighted-text">{{ userEmail$ | async }}</span>
    <span class="subtext" i18n> below.</span>
  </div>
</div>

<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'code'" i18n>Verification Code</label>
      <app-text-input
        #codeInput
        formControlName="code"
        controlId="code"
        [error]="formSubmitted && formGroup.controls.code.invalid"
        (keydown.enter)="verifyEmail()" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.code.invalid"
        [errors]="formGroup.controls.code.errors"
        [customErrorMessages]="customErrorMessages.code" />
    </div>
  </div>

  <div class="sign-in-button-container">
    <app-button class="w-100" [type]="ButtonTypeEnum.primary" (buttonClick)="verifyEmail()" i18n>
      Verify Email
    </app-button>
  </div>
</div>

<div class="support-button-container">
  <span class="support-button" i18n>Having trouble?</span>
  <button class="paddingless-text-button mt-2" (click)="openContactPage()" i18n>Click here for support</button>
</div>
